import { Box, FlexColBox, Input } from "../../../common/components";
import { Typography } from "@mui/material";
import { palette } from "../../../styles/theme";
import { useTranslation } from "react-i18next";
import NonLinearSlider from "../../../common/components/Slider/NonLinearSlider";
import { useAuth } from "../../../common/hooks/useAuth";

interface Props {
  canViewDistributorSection: boolean;
  onQtyChange: (value: number | string | undefined) => void;
  qty: number;
  minQty: number;
  regularUserMaxOrderSize: number;
  distributorMaxOrderSize: number;
  productName: string;
}

const QuantitySection = ({
  canViewDistributorSection,
  onQtyChange,
  qty,
  minQty,
  regularUserMaxOrderSize = 149,
  distributorMaxOrderSize = 499,
  productName,
}: Props) => {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();
  const productType = productName.toLowerCase().includes("socks")
    ? "socks"
    : "others";

  return (
    <FlexColBox gap={"18px"}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-end">
        <FlexColBox gap="8px">
          <Typography variant="h2">{t("pricing.quantity")}</Typography>
          {canViewDistributorSection && (
            <Typography variant="textSm" color={palette.grey.primary}>
              {isAdmin
                ? t("pricing.distributorQuantityDisclaimer", {
                    regularUserMaxOrderSize,
                    distributorMaxOrderSize,
                  })
                : t("pricing.regularUserQuantityDisclaimer", {
                    regularUserMaxOrderSize,
                  })}
            </Typography>
          )}
        </FlexColBox>
        <Input
          type="number"
          onChange={(event) =>
            onQtyChange(event.target.value ? parseInt(event.target.value) : 0)
          }
          value={qty === 0 ? "" : qty.toString()}
          inputProps={{ min: 0 }}
          containerSx={{ maxWidth: "100px" }}
        />
      </Box>
      <FlexColBox gap="8px">
        <NonLinearSlider onChange={onQtyChange} value={qty} />
        {qty < minQty && (
          <Typography variant="textSm" color={palette.red.error}>
            {t("pricing.minQtyError", {
              minQty: minQty,
              context: productType,
            })}
          </Typography>
        )}
      </FlexColBox>
    </FlexColBox>
  );
};

export default QuantitySection;
